/**
 * DEV-ONLY: Classic (default) layout inspector panel UI.
 * Implementation lives in LayoutInspectorPanel.jsx — this module is the stable export name.
 */
export { default } from "./LayoutInspectorPanel";
